export default [
    {
        path: "/site/user-dashboard",
        name: "user_dashboard",
        component: () =>
            import("@/views/dashboard/todays-words-carousel/Carousel.vue"),
        meta: {
            contentRenderer: "sidebar-left"
        }
    },
    {
        path: "/site/dashboard/analytics",
        name: "dashboard-analytics",
        component: () => import("@/views/dashboard/analytics/Analytics.vue")
    },
    {
        path: "/site/dashboard",
        name: "dashboard",
        component: () => import("@/views/dashboard/Dashboard.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/git-command",
        name: "GitCommand",
        component: () => import("@/views/dashboard/GitCommand.vue")
    },
    // {
    //   path: '/dashboard',
    //   name: 'dashboard',
    //   component: () => import('@/views/dashboard/ecommerce/Ecommerce.vue'),
    // },
    {
        path: "/site/practice_subject_list/:id",
        name: "practice_subject_list",
        component: () => import("@/views/dashboard/PracticeSubjectList.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/practice_chapter_list/:id/:category_id",
        name: "practice_chapter_list",
        component: () => import("@/views/dashboard/PracticeChapterList.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/practice_chapter_details_list/:id/:category_id",
        name: "practice_chapter_details_list",
        component: () => import("@/views/dashboard/PracticeChapterDetails.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/practice_chapter_details_list_by_id/:id",
        name: "practice_chapter_details_list_by_id",
        component: () => import("@/views/dashboard/PracticeChapterDetailsById.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/practice_chapter_wise_list/:chapter/:category_id",
        name: "practice_chapter_wise_list",
        component: () =>
            import("@/views/dashboard/StartPracticeChapterWise.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/quiz_chapter_wise_list/:value/:category_id",
        name: "quiz_chapter_wise_list",
        component: () => import("@/views/dashboard/StartQuiz.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/quiz_result/:marks/:qids",
        name: "quiz_result",
        component: () => import("@/views/dashboard/QuizResult.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/course_details/:id",
        name: "course_details",
        component: () => import("@/views/dashboard/CourseDetails.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/upgrade_pricing",
        name: "upgrade_pricing",
        component: () => import("@/views/dashboard/UpgradePricing.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/subscription-payment-successful",
        name: "subscription_payment_successful",
        component: () => import("@/views/dashboard/PaymentSuccess.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/subscription-payment-failed",
        name: "subscription_payment_failed",
        component: () => import("@/views/dashboard/PaymentFail.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/subscription-payment-canceled",
        name: "subscription_payment_canceled",
        component: () => import("@/views/dashboard/PaymentCancel.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/profile",
        name: "profile",
        component: () => import("@/views/profile/Profile.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/profile_setting",
        name: "profile_setting",
        component: () => import("@/views/profile-setting/ProfileSetting.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/create-study-group",
        name: "CreateStudyGroup",
        component: () => import("@/views/study-group/CreateStudyGroup.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/study-group/:id/:invitation_token?",
        name: "StudyGroupPage",
        component: () => import("@/views/study-group/StudyGroupPage.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/my_panel/mistake_list/:id?",
        name: "my_panel_mistake_list",
        component: () => import("@/views/mypanel/MistakeList.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/my-panel/review_list/:id?",
        name: "my_panel_review_list",
        component: () => import("@/views/mypanel/ReviewList.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/my-panel/chapter-quiz-list/:id?",
        name: "my_panel_chapter_quiz_list",
        component: () => import("@/views/mypanel/ChapterQuizList.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/my-panel/quiz_result_details/:quiz_id",
        name: "my_panel_quiz_result_details",
        component: () => import("@/views/mypanel/QuizResultDetails.vue"),
        meta: {
            auth: true
        }
    },
    // my-panel routes
    {
        path: "/site/my_panel/read_and_practice",
        name: "my_panel_read_and_practice",
        component: () => import("@/views/mypanel/ReadAndPractice.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/my_panel/current_affairs",
        name: "my_panel_current_affairs",
        component: () => import("@/views/mypanel/CurrentAffairs.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/my_panel/courses",
        name: "my_panel_courses",
        component: () => import("@/views/mypanel/Courses.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/my_panel/vocabulary-app",
        name: "my_panel_vocabulary_app",
        component: () => import("@/views/mypanel/VocabularyApp.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/my_panel/vocabulary-practice-list",
        name: "my_panel_vocabulary_practice_list",
        component: () => import("@/views/mypanel/VocabularyPracticeList.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/assessment",
        name: "my_panel_assessment_test",
        component: () => import("@/views/mypanel/AssessmentTest.vue"),
        meta: {
            layout: "full",
            resource: "Auth",
            auth: true
        }
    },
    {
        path: "/site/user-enrollment",
        name: "site_user_enrollment",
        component: () => import("@/views/mypanel/UserEnrollment.vue"),
        meta: {
            layout: "full",
            resource: "Auth",
            auth: true
        }
    },
    {
        path: "/site/my_panel/vocabulary-mistake-list",
        name: "my_panel_vocabulary_mistake_list",
        component: () => import("@/views/mypanel/VocabularyMistakeList.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/my_panel/pricing",
        name: "my_panel_pricing",
        component: () => import("@/views/mypanel/Pricing.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/payment/:id",
        name: "payment",
        component: () => import("@/views/mypanel/Payment.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/my_panel/previous_year_model_test_category",
        name: "my_panel_previous_year_model_test_category",
        component: () => import("@/views/mypanel/CategoryList.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/my_panel/previous_year_model_test_list_by_category/:id",
        name: "my_panel_previous_year_model_test_list_by_category",
        component: () => import("@/views/mypanel/PreviousYearModelTest.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/my_panel/previous_year_model_test_exam_datails/:id",
        name: "my_panel_previous_year_model_test_exam_datails",
        component: () => import("@/views/mypanel/ModelTestExamDetails.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/my-panel/model_test_result/:id?",
        name: "my_panel_model_test_list",
        component: () => import("@/views/mypanel/MyModelTestList.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/my-panel/previous-question-list/:id?",
        name: "my_panel_previous_question_list",
        component: () => import("@/views/mypanel/PreviousQuestionList.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/my-panel/model_test_result_details/:id",
        name: "my_panel_model_test_result_details",
        component: () => import("@/views/mypanel/MyModelTestResultDetails.vue"),
        meta: {
            auth: true
        }
    },
    // model_test routes
    {
        path: "/site/model_test/all_category",
        name: "model_test_all_category",
        component: () => import("@/views/model_test/ModelTestCategoryList.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/model_test/all_list_by_category/:id",
        name: "model_test_all_list_by_category",
        component: () => import("@/views/model_test/ListByCategory.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/model_test/live_category",
        name: "model_test_live_category",
        component: () =>
            import("@/views/model_test/ModelTestLiveCategoryList.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/model_test/live_list_by_category",
        name: "model_test_live_list_by_category",
        component: () => import("@/views/model_test/LiveListByCategory.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/model_test/details/:id",
        name: "model_test_details",
        component: () => import("@/views/model_test/ModelTestDetails.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/model_test/live_details/:id",
        name: "model_test_live_details",
        component: () => import("@/views/model_test/LiveModelTestDetails.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/model_test/start_model_test/:id",
        name: "model_test_start_model_test",
        component: () =>
            import("@/views/model_test/StartModelTestWithCountDownTimer.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/model_test/start_model_test_live/:id",
        name: "model_test_start_model_test_live",
        component: () => import("@/views/model_test/StartModelTestLive.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/model_test/result/:id",
        name: "model_test_result",
        component: () => import("@/views/model_test/ModelTestResult.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/site/model_test/view_all_participants/:id",
        name: "model_test_view_all_participants",
        component: () => import("@/views/model_test/ModelTestParticipants.vue"),
        meta: {
            auth: true
        }
    },
    // studypress routes
    {
        path: "/site/studypress/updates",
        name: "studypress_updates",
        component: () => import("@/views/studypress/Updates.vue")
    },
    {
        path: "/site/studypress/help",
        name: "studypress_help",
        component: () => import("@/views/studypress/Help.vue")
    },
    {
        path: "/site/studypress/contact",
        name: "studypress_contact",
        component: () => import("@/views/studypress/Contact.vue")
    },
    // pages routes
    {
        path: "/site/error-404",
        name: "error-404",
        component: () => import("@/views/error/Error404.vue"),
        meta: {
            layout: "full",
            resource: "Auth",
            action: "read"
        }
    },
    {
        path: "/site/login",
        name: "auth-login",
        component: () => import("@/views/pages/authentication/Login.vue"),
        meta: {
            layout: "full",
            resource: "Auth",
            redirectIfLoggedIn: true,
            auth: false
        }
    },
    // {
    //     path: "/site/pages/authentication/login-v1",
    //     name: "auth-login-v1",
    //     component: () => import("@/views/pages/authentication/Login-v1.vue"),
    //     meta: {
    //         layout: "full"
    //     }
    // },
    // {
    //     path: "/site/pages/authentication/login-v2",
    //     name: "auth-login-v2",
    //     component: () => import("@/views/pages/authentication/Login-v2.vue"),
    //     meta: {
    //         layout: "full"
    //     }
    // },
    {
        path: "/site/register/:invitation_token?",
        name: "auth-register",
        component: () => import("@/views/pages/authentication/Register.vue"),
        meta: {
            layout: "full",
            resource: "Auth",
            redirectIfLoggedIn: true,
            auth: false
        }
    },
    {
        path: "/site/18-ntrca-school-teacher-registration",
        name: "ntrca-register",
        component: () => import("@/views/pages/authentication/NtrcaRegister.vue"),
        meta: {
            layout: "full",
            resource: "Auth",
            redirectIfLoggedIn: true,
            auth: false
        }
    },
    // {
    //     path: "/site/pages/authentication/register-v1",
    //     name: "auth-register-v1",
    //     component: () => import("@/views/pages/authentication/Register-v1.vue"),
    //     meta: {
    //         layout: "full"
    //     }
    // },
    // {
    //     path: "/site/pages/authentication/register-v2",
    //     name: "auth-register-v2",
    //     component: () => import("@/views/pages/authentication/Register-v2.vue"),
    //     meta: {
    //         layout: "full"
    //     }
    // },
    {
        path: "/site/forgot-password",
        name: "auth-forgot-password",
        component: () =>
            import("@/views/pages/authentication/ForgotPassword.vue"),
        meta: {
            layout: "full",
            resource: "Auth",
            redirectIfLoggedIn: true,
            auth: false
        }
    },
    {
        path: "/site/privacy-policy-and-terms",
        name: "privacy-policy-and-terms",
        component: () =>
            import("@/views/pages/authentication/PrivaciyPolicyAndTerms.vue"),
        meta: {
            layout: "full",
            resource: "Auth",
            redirectIfLoggedIn: true,
            auth: false
        }
    },
    // {
    //     path: "/site/pages/authentication/forgot-password-v1",
    //     name: "auth-forgot-password-v1",
    //     component: () =>
    //         import("@/views/pages/authentication/ForgotPassword-v1.vue"),
    //     meta: {
    //         layout: "full"
    //     }
    // },
    // {
    //     path: "/site/pages/authentication/forgot-password-v2",
    //     name: "auth-forgot-password-v2",
    //     component: () =>
    //         import("@/views/pages/authentication/ForgotPassword-v2.vue"),
    //     meta: {
    //         layout: "full",
    //         resource: "Auth"
    //     }
    // },
    {
        path: "/site/pages/authentication/reset-password/:token",
        name: "auth-reset-password",
        component: () =>
            import("@/views/pages/authentication/ResetPassword.vue"),
        meta: {
            layout: "full",
            resource: "Auth",
            redirectIfLoggedIn: true,
            auth: false
        }
    },
    // {
    //     path: "/site/pages/authentication/reset-password-v1",
    //     name: "auth-reset-password-v1",
    //     component: () =>
    //         import("@/views/pages/authentication/ResetPassword-v1.vue"),
    //     meta: {
    //         layout: "full"
    //     }
    // },
    // {
    //     path: "/site/pages/authentication/reset-password-v2",
    //     name: "auth-reset-password-v2",
    //     component: () =>
    //         import("@/views/pages/authentication/ResetPassword-v2.vue"),
    //     meta: {
    //         layout: "full"
    //     }
    // },
    // {
    //     path: "/site/pages/miscellaneous/coming-soon",
    //     name: "misc-coming-soon",
    //     component: () => import("@/views/pages/miscellaneous/ComingSoon.vue"),
    //     meta: {
    //         layout: "full"
    //     }
    // },
    {
        path: "/site/pages/miscellaneous/not-authorized",
        name: "misc-not-authorized",
        component: () =>
            import("@/views/pages/miscellaneous/NotAuthorized.vue"),
        meta: {
            layout: "full",
            resource: "Auth"
        }
    },
    // {
    //     path: "/site/pages/miscellaneous/under-maintenance",
    //     name: "misc-under-maintenance",
    //     component: () =>
    //         import("@/views/pages/miscellaneous/UnderMaintenance.vue"),
    //     meta: {
    //         layout: "full"
    //     }
    // },
    {
        path: "/site/pages/miscellaneous/error",
        name: "misc-error",
        component: () => import("@/views/pages/miscellaneous/Error.vue"),
        meta: {
            layout: "full"
        }
    },
    // {
    //     path: "/site/pages/account-setting",
    //     name: "pages-account-setting",
    //     component: () =>
    //         import("@/views/pages/account-setting/AccountSetting.vue"),
    //     meta: {
    //         pageTitle: "Account Settings",
    //         breadcrumb: [
    //             {
    //                 text: "Pages"
    //             },
    //             {
    //                 text: "Account Settings",
    //                 active: true
    //             }
    //         ]
    //     }
    // },
    {
        path: "/site/pages/profile",
        name: "pages-profile",
        component: () => import("@/views/pages/profile/Profile.vue"),
        meta: {
            pageTitle: "Profile",
            breadcrumb: [
                {
                    text: "Pages"
                },
                {
                    text: "Profile",
                    active: true
                }
            ]
        }
    },
    // {
    //     path: "/site/pages/faq",
    //     name: "pages-faq",
    //     component: () => import("@/views/pages/faq/Faq.vue"),
    //     meta: {
    //         pageTitle: "FAQ",
    //         breadcrumb: [
    //             {
    //                 text: "Pages"
    //             },
    //             {
    //                 text: "FAQ",
    //                 active: true
    //             }
    //         ]
    //     }
    // },
    // {
    //     path: "/site/pages/knowledge-base",
    //     name: "pages-knowledge-base",
    //     component: () =>
    //         import("@/views/pages/Knowledge-base/KnowledgeBase.vue"),
    //     meta: {
    //         pageTitle: "Knowledge Base",
    //         breadcrumb: [
    //             {
    //                 text: "Pages"
    //             },
    //             {
    //                 text: "Knowledge Base",
    //                 active: true
    //             }
    //         ]
    //     }
    // },
    {
        path: "/site/pages/knowledge-base/:category",
        name: "pages-knowledge-base-category",
        component: () =>
            import("@/views/pages/Knowledge-base/KnowledgeBaseCategory.vue"),
        meta: {
            pageTitle: "Category",
            breadcrumb: [
                {
                    text: "Pages"
                },
                {
                    text: "Knowledge Base",
                    to: "/pages/Knowledge-base"
                },
                {
                    text: "Category",
                    active: true
                }
            ],
            navActiveLink: "pages-knowledge-base"
        }
    },
    // {
    //     path: "/site/pages/knowledge-base/:category/:slug",
    //     name: "pages-knowledge-base-question",
    //     component: () =>
    //         import(
    //             "@/views/pages/Knowledge-base/KnowledgeBaseCategoryQuestion.vue"
    //         ),
    //     meta: {
    //         pageTitle: "Question",
    //         breadcrumb: [
    //             {
    //                 text: "Pages"
    //             },
    //             {
    //                 text: "Knowledge Base",
    //                 to: "/pages/Knowledge-base"
    //             },
    //             {
    //                 text: "Category",
    //                 to: "/pages/Knowledge-base/category"
    //             },
    //             {
    //                 text: "Question",
    //                 active: true
    //             }
    //         ],
    //         navActiveLink: "pages-knowledge-base"
    //     }
    // },
    {
        path: "/site/pages/pricing",
        name: "pages-pricing",
        component: () => import("@/views/pages/pricing/Pricing.vue")
    },
    // {
    //     path: "/site/pages/blog/list",
    //     name: "pages-blog-list",
    //     component: () => import("@/views/pages/blog/BlogList.vue"),
    //     meta: {
    //         pageTitle: "Blog List",
    //         breadcrumb: [
    //             {
    //                 text: "Pages"
    //             },
    //             {
    //                 text: "Blog"
    //             },
    //             {
    //                 text: "List",
    //                 active: true
    //             }
    //         ]
    //     }
    // },
    // {
    //     path: "/site/pages/blog/:id",
    //     name: "pages-blog-detail",
    //     component: () => import("@/views/pages/blog/BlogDetail.vue"),
    //     meta: {
    //         pageTitle: "Blog Detail",
    //         breadcrumb: [
    //             {
    //                 text: "Pages"
    //             },
    //             {
    //                 text: "Blog"
    //             },
    //             {
    //                 text: "Detail",
    //                 active: true
    //             }
    //         ]
    //     }
    // },
    // {
    //     path: "/site/pages/blog/edit/:id",
    //     name: "pages-blog-edit",
    //     component: () => import("@/views/pages/blog/BlogEdit.vue"),
    //     meta: {
    //         pageTitle: "Blog Edit",
    //         breadcrumb: [
    //             {
    //                 text: "Pages"
    //             },
    //             {
    //                 text: "Blog"
    //             },
    //             {
    //                 text: "Edit",
    //                 active: true
    //             }
    //         ]
    //     }
    // },
    {
        path: '/auth/:provider/callback',
        component: {
            template: '<div class="auth-component"></div>'
        }
    },
];
